/* eslint-disable */
import * as Types from '../../../../../../generated/graphql'

import { gql } from '@apollo/client'
export type GQLPhotosFragment = {
  __typename?: 'PublicProfile'
  photos: {
    __typename?: 'ProfilePhotos'
    photosCount: number
    photos: {
      __typename?: 'PublicPhotosConnection'
      nodes: Array<{
        __typename?: 'Photo'
        main: boolean
        width: number
        height: number
        portrait: boolean
        verified: boolean
        voted: boolean
        voteable: boolean
        likes: number
        liked: boolean
        photoId: any
        urls: {
          __typename?: 'PhotoUrls'
          huge: string
          square: string
          squareLarge: string
          squareSmall: string
          xHuge?: string | null
        }
        faceCenter?: {
          __typename?: 'PhotoFaceCenter'
          xHuge?: { __typename?: 'PixelPoint'; x: number; y: number } | null
          huge?: { __typename?: 'PixelPoint'; x: number; y: number } | null
        } | null
      }>
      pageInfo: {
        __typename?: 'PageInfo'
        hasNextPage: boolean
        endCursor: any
      }
    }
    default?: {
      __typename?: 'Photo'
      main: boolean
      width: number
      height: number
      portrait: boolean
      verified: boolean
      voted: boolean
      voteable: boolean
      likes: number
      liked: boolean
      photoId: any
      urls: {
        __typename?: 'PhotoUrls'
        huge: string
        square: string
        squareLarge: string
        squareSmall: string
        xHuge?: string | null
      }
      faceCenter?: {
        __typename?: 'PhotoFaceCenter'
        xHuge?: { __typename?: 'PixelPoint'; x: number; y: number } | null
        huge?: { __typename?: 'PixelPoint'; x: number; y: number } | null
      } | null
    } | null
  }
}

export type GQLPhotoItemFragment = {
  __typename?: 'Photo'
  main: boolean
  width: number
  height: number
  portrait: boolean
  verified: boolean
  voted: boolean
  voteable: boolean
  likes: number
  liked: boolean
  photoId: any
  urls: {
    __typename?: 'PhotoUrls'
    huge: string
    square: string
    squareLarge: string
    squareSmall: string
    xHuge?: string | null
  }
  faceCenter?: {
    __typename?: 'PhotoFaceCenter'
    xHuge?: { __typename?: 'PixelPoint'; x: number; y: number } | null
    huge?: { __typename?: 'PixelPoint'; x: number; y: number } | null
  } | null
}

export type GQLDefaultPhotoFragment = {
  __typename?: 'ProfilePhotos'
  default?: {
    __typename?: 'Photo'
    main: boolean
    width: number
    height: number
    portrait: boolean
    verified: boolean
    voted: boolean
    voteable: boolean
    likes: number
    liked: boolean
    photoId: any
    urls: {
      __typename?: 'PhotoUrls'
      huge: string
      square: string
      squareLarge: string
      squareSmall: string
      xHuge?: string | null
    }
    faceCenter?: {
      __typename?: 'PhotoFaceCenter'
      xHuge?: { __typename?: 'PixelPoint'; x: number; y: number } | null
      huge?: { __typename?: 'PixelPoint'; x: number; y: number } | null
    } | null
  } | null
}

export const PhotoItemFragmentDoc = gql`
  fragment PhotoItem on Photo {
    photoId: id
    urls {
      huge
      square
      squareLarge
      squareSmall
      xHuge
    }
    main
    width
    height
    faceCenter {
      xHuge {
        x
        y
      }
      huge {
        x
        y
      }
    }
    portrait
    verified
    voted
    voteable
    likes
    liked
  }
`
export const DefaultPhotoFragmentDoc = gql`
  fragment DefaultPhoto on ProfilePhotos {
    default {
      ...PhotoItem
    }
  }
  ${PhotoItemFragmentDoc}
`
export const PhotosFragmentDoc = gql`
  fragment Photos on PublicProfile {
    photos {
      photosCount
      ...DefaultPhoto
      photos(limit: 100) {
        nodes {
          ...PhotoItem
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
  ${DefaultPhotoFragmentDoc}
  ${PhotoItemFragmentDoc}
`
